var _rect, _rect2, _rect3, _rect4, _rect5, _line, _path, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg4Xx = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 70,
  height: 40,
  viewBox: "0 0 70 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 2,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 4,
  width: 2,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 4,
  width: 2,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 4,
  width: 48,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 64,
  y: 4,
  width: 2,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 1,
  y1: 9,
  x2: 69,
  y2: 9,
  stroke: "currentColor",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.1835 25.16H27.1835V21.46C27.1835 21.1133 27.1968 20.7 27.2235 20.22C27.2502 19.74 27.2702 19.3333 27.2835 19H27.2035C27.0435 19.3067 26.8768 19.6067 26.7035 19.9C26.5302 20.1933 26.3502 20.4933 26.1635 20.8L23.1835 25.16ZM27.1835 30V26.48H21.4435V25.4L26.9035 17.24H28.7435V25.16H30.4835V26.48H28.7435V30H27.1835ZM31.3249 30L34.5049 24.92L31.5649 20.28H33.3449L34.6449 22.42C34.7916 22.6733 34.9449 22.94 35.1049 23.22C35.2649 23.5 35.4316 23.7733 35.6049 24.04H35.6849C35.8316 23.7733 35.9783 23.5 36.1249 23.22C36.2716 22.94 36.4183 22.6733 36.5649 22.42L37.7449 20.28H39.4649L36.5249 25.1L39.6849 30H37.9049L36.4849 27.74C36.3116 27.4467 36.1383 27.1533 35.9649 26.86C35.7916 26.5667 35.6116 26.28 35.4249 26H35.3449C35.1716 26.28 35.0049 26.5667 34.8449 26.86C34.6849 27.14 34.5249 27.4333 34.3649 27.74L33.0449 30H31.3249ZM40.2507 30L43.4307 24.92L40.4907 20.28H42.2707L43.5707 22.42C43.7174 22.6733 43.8707 22.94 44.0307 23.22C44.1907 23.5 44.3574 23.7733 44.5307 24.04H44.6107C44.7574 23.7733 44.904 23.5 45.0507 23.22C45.1974 22.94 45.344 22.6733 45.4907 22.42L46.6707 20.28H48.3907L45.4507 25.1L48.6107 30H46.8307L45.4107 27.74C45.2374 27.4467 45.064 27.1533 44.8907 26.86C44.7174 26.5667 44.5374 26.28 44.3507 26H44.2707C44.0974 26.28 43.9307 26.5667 43.7707 26.86C43.6107 27.14 43.4507 27.4333 43.2907 27.74L41.9707 30H40.2507Z",
  fill: "currentColor"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 68,
  height: 38,
  rx: 4,
  stroke: "currentColor",
  strokeWidth: 2,
  fill: "transparent"
})));
export default Svg4Xx;